"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
const common_1 = require("../../../@inax/common");
let InaxFrontendService = class InaxFrontendService {
    constructor(_http, _configuration, _profileService) {
        this._http = _http;
        this._configuration = _configuration;
        this._profileService = _profileService;
    }
    /***********************************************************************
     *          WEB API
     * ********************************************************************/
    /**
     * Returns the name and the IP address of the caller.
     * @method whoAmI
     * @return {Observable<any>} TODO
     */
    whoAmI() {
        let accessUrl = this._configuration.buildRestUrl("Frontend", "WhoAmI");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    /**
     * Read configuration values from the INAX.config
     * @method whoAmI
     * @return {Observable<any>} TODO
     */
    readConfigValue(propertyName, defaultValue) {
        let accessUrl = this._configuration.buildRestUrl("Frontend", "ReadConfigValue") + "?propertyName=" + propertyName + "&defaultValue=" + defaultValue;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    /**
     * Returns false if INAX is not licensed at the time of checking
     * @method whoAmI
     * @return {Observable<any>} TODO
     */
    isInaxLicensed() {
        let accessUrl = this._configuration.buildRestUrl("Frontend", "IsInaxLicensed");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    /**
     * INAX restarts the Webservice
     * @method whoAmI
     * @return {Observable<any>} TODO
     */
    restartWebServer(uri) {
        let accessUrl = this._configuration.buildRestUrl("Frontend", "RestartWebServer") + "?uri=" + uri;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, null, { headers }).map(res => res.json());
    }
    /**
     * Reload the user defined types
     * @method whoAmI
     * @return {Observable<any>} TODO
     */
    reloadCustomData(path) {
        let accessUrl = this._configuration.buildRestUrl("Frontend", "ReloadCustomData") + "?path=" + path;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, null, { headers }).map(res => res.json());
    }
    /**
     * All components will be restarted
     * @method whoAmI
     * @return {Observable<any>} TODO
     */
    restartComponents() {
        let accessUrl = this._configuration.buildRestUrl("Frontend", "RestartComponents");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, null, { headers }).map(res => res.json());
    }
    /**
     * Restart the given component
     * @method whoAmI
     * @return {Observable<any>} TODO
     */
    restartComponent(componentName) {
        let accessUrl = this._configuration.buildRestUrl("Frontend", "RestartComponents") + "?componentName=" + componentName;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, null, { headers }).map(res => res.json());
    }
};
InaxFrontendService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        common_1.InaxConfiguration,
        common_1.ProfileService])
], InaxFrontendService);
exports.InaxFrontendService = InaxFrontendService;
